/**
 * Ordering for the app-version and goggles-firmware filter dropdowns.
 *
 * Firmware is major.minor.patch.build (e.g. 1.2.1.16) and app versions are
 * dotted numbers, so both compare numerically part by part: 1.2.1.16 sorts
 * above 1.2.1.9, which a string sort gets backwards.
 */

const isUnknown = (v) => v == null || String(v).trim() === '' || String(v).trim().toLowerCase() === 'unknown';

const numericParts = (v) => (String(v).match(/\d+/g) || []).map(Number);

// Positive when `a` is the newer version.
const compareNewer = (a, b) => {
  const pa = numericParts(a);
  const pb = numericParts(b);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const na = pa[i] || 0;
    const nb = pb[i] || 0;
    if (na !== nb) return na - nb;
  }
  return 0;
};

/**
 * Returns a new array ordered newest to oldest. "unknown" (or blank) goes
 * first, and any other value with no digits goes last.
 */
export const sortVersionsDesc = (versions) => [...versions].sort((a, b) => {
  const aUnknown = isUnknown(a);
  const bUnknown = isUnknown(b);
  if (aUnknown || bUnknown) return aUnknown === bUnknown ? 0 : (aUnknown ? -1 : 1);

  const aNumeric = numericParts(a).length > 0;
  const bNumeric = numericParts(b).length > 0;
  if (!aNumeric || !bNumeric) {
    return aNumeric === bNumeric ? String(a).localeCompare(String(b)) : (aNumeric ? -1 : 1);
  }

  return compareNewer(b, a) || String(b).localeCompare(String(a));
});
